module.exports = __webpack_public_path__ + "res/Roboto-BoldCondensed-webfont.svg?52029bf8170545f8d100f93a7d852201";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-BoldCondensed-webfont.svg
// module id = 50
// module chunks = 0